export const money = (n) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency', currency: 'USD', maximumFractionDigits: 0,
  }).format(n || 0);

export const initials = (s = '') =>
  s.split(/\s+/).filter(Boolean).slice(0, 2).map(w => w[0]).join('').toUpperCase();

export const fmtDate = (s) => {
  if (!s) return '';
  const d = new Date(s);
  return isNaN(d) ? String(s) : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

export const fmtDateTime = (s) => {
  if (!s) return '';
  const d = new Date(s);
  return isNaN(d) ? String(s)
    : d.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
};

export const firstName = (s) => (s || '').split(' ')[0] || '';

/** Falls back to the legacy single-line `address` field for older records. */
export function composeAddress(c) {
  if (!c) return '';
  const line1 = [c.address1, c.address2].filter(Boolean).join(', ');
  const cityStateZip = [c.city, [c.state, c.zip].filter(Boolean).join(' ').trim()]
    .filter(Boolean).join(', ');
  return [line1, cityStateZip].filter(Boolean).join(', ') || c.address || '';
}

// Item normalisation and the subtotal/tax/total maths live in src/shared so
// the browser and the PDF renderer compute from identical code — two
// implementations could quote the same customer two different prices.
export { normItem, normSection, normSections, proposalTotals, legacyTotal } from '@shared/docMath.mjs';

/** Site-visit measurements were once a {label: value} map, now an array. */
export function normMeasurements(m) {
  if (Array.isArray(m)) return m.map(x => ({ label: x.label || '', value: x.value ?? '', unit: x.unit || '' }));
  if (m && typeof m === 'object') return Object.entries(m).map(([k, v]) => ({ label: k, value: v, unit: '' }));
  return [];
}

